import React from 'react';
import cn from 'classnames/bind';
import styles from './List.scss';
import { ROOT_URL } from '../../../../../constants/Config.js';

import placeholder from '../../../../../assets/images/banner-placeholder.jpg';
import { useTranslation } from 'react-i18next';
import { gaEvent, trackGA } from 'services/ga.js';

const cx = cn.bind(styles);

const addDefaultSrc = (ev) => {
  ev.target.src = placeholder;
};

const itemCards = (
  galleryData,
  galleryRef,
  albums,
  onImage,
  currentAlbum,
  profile,
  buildingData,
  objectType,
) => {
  const { t } = useTranslation();

  const handleTrackEvent = ({ eventContent }) => {
    const { title, id } = buildingData;

    trackGA(gaEvent.buildingGalleryAlbumsButtonsClick({
      eventContent,
      productType: objectType,
      productName: title,
      productID: id,
      user_id: profile.id
    }));
  };

  return albums.rows.map((a, i) => a.images ?
    (
      <div
        onClick={() => {
          onImage.bind(this, galleryData.metaForGallery.meta[i].first, i)();
          galleryRef.slideToIndex(galleryData.metaForGallery.meta[i].first);
          handleTrackEvent({
            eventContent: (galleryData.metaForGallery.meta[i].month && galleryData.metaForGallery.meta[i].year) ? (
              `${galleryData.metaForGallery.meta[i].month ? `${galleryData.metaForGallery.meta[i].month} ${galleryData.metaForGallery.meta[i].year !== 0 ? galleryData.metaForGallery.meta[i].year : ''}` : ''}`
          ) : `${a.type.name}`
          });
        }}
        onMouseUp={() => {
          onImage.bind(this, galleryData.metaForGallery.meta[i].first, i)();
          galleryRef.slideToIndex(galleryData.metaForGallery.meta[i].first);
        }}
        className={cx(styles.Item, { ActiveItem: i === currentAlbum })}
        key={i}
      >
        <div className={styles.Image}>
          <img
            onError={addDefaultSrc}
            alt="preview album"
            src={`${ROOT_URL}/image?id=${a.images[0].id}&size=medium`}
          />
        </div>
        <div className={styles.Text}>
          <div className={styles.Name}>
            {(galleryData.metaForGallery.meta[i].month && galleryData.metaForGallery.meta[i].year) ? (
                  `${galleryData.metaForGallery.meta[i].month ? `${galleryData.metaForGallery.meta[i].month} ${galleryData.metaForGallery.meta[i].year !== 0 ? galleryData.metaForGallery.meta[i].year : ''}` : ''}`
              ) : `${a.type.name}`}
          </div>
          <div className={styles.Label}>
            {a.images ? a.images.length : 0} {t('components.building.main.popup.photo')}
          </div>
        </div>
      </div>
    ) : null);
};

const List = ({
  className,
  galleryData,
  galleryRef,
  albums,
  onImage,
  currentAlbum,
  profile,
  buildingData,
  objectType
}) => (
    albums.rows.length > 1 ?
      <div className={cn(styles.List, className)}>
        {itemCards(
          galleryData,
          galleryRef,
          albums,
          onImage,
          currentAlbum,
          profile,
          buildingData,
          objectType
        )}
      </div> : null
  );


export default List;



// WEBPACK FOOTER //
// ./src/components/Building/Main/Popup/List/List.js